import { Chip } from "@mui/material";
import {
  CarrierLogo as SharedCarrierLogo,
  type ShipmentCarrier,
} from "shared-ui/src/features/it-projects-feature";

interface CarrierLogoProps {
  carrier: ShipmentCarrier;
  carrierName?: string | null;
}

// Carriers without a logo fall back to a chip with the carrier name.
export function CarrierLogo({ carrier, carrierName }: Readonly<CarrierLogoProps>) {
  if (carrier !== "Other") {
    return <SharedCarrierLogo carrier={carrier} />;
  }

  return (
    <Chip
      label={carrierName?.trim() || "Other carrier"}
      size="small"
      variant="outlined"
      sx={{ userSelect: "none", fontWeight: "normal" }}
    />
  );
}

export function formatCarrierLogoCarrier(
  carrierEnum: string | null | undefined,
): ShipmentCarrier {
  switch (carrierEnum?.trim().toLowerCase()) {
	case "ups":
	  return "UPS";
	case "fedex":
	  return "FedEx";
	case "dhl":
	  return "DHL";
	default:
	  return "Other";
  }
}

